import { useTranslation } from "@refinedev/core";
import { Zap, Shield, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

const Fipix = () => {
  const { translate } = useTranslation();

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <main className="flex-1 overflow-y-auto">
        <div className="p-4">
          <div className="bg-gradient-to-r from-brand-400 to-brand-500 rounded-2xl overflow-hidden shadow-xl mb-6">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="w-full lg:w-1/2 px-8 py-6 lg:px-10 text-white">
                <h2 className="text-xl xl:text-2xl 2xl:text-4xl font-bold mb-4">
                  {translate("fipix.title")}
                </h2>
                <p className="text-lg mb-4 text-blue-50">
                  {translate("fipix.subtitle")}
                </p>
                <Link to={"https://fipix.net/"} target="_blank">
                  <button className="px-6 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all transform hover:scale-105 shadow-lg">
                    {translate("fipix.cta")}
                  </button>
                </Link>
              </div>

              <div className="w-full lg:w-1/2 flex items-center justify-center">
                <div className="text-center text-white">
                  <img src="/images/fipix/hero-banner.jpg" className="w-full h-full object-fill" />
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-6 lg:p-8 mb-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3">
                {translate("fipix.aboutTitle")}
              </h3>
              <div className="w-16 h-1 bg-brand-600 mx-auto"></div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="mx-auto rounded-xl overflow-hidden h-fit md:order-last">
                <img src="/images/fipix/step.jpg" className="max-w-full" />
              </div>
              <div className="bg-gray-50 rounded-xl p-6 h-fit">
                <p className="leading-relaxed text-lg">
                  {translate("fipix.description")}
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-6">
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <Zap className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {translate("fipix.features.fast.title")}
              </h3>
              <p className="text-gray-600 text-sm">
                {translate("fipix.features.fast.desc")}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <Shield className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {translate("fipix.features.secure.title")}
              </h3>
              <p className="text-gray-600 text-sm">
                {translate("fipix.features.secure.desc")}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <CheckCircle className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {translate("fipix.features.accurate.title")}
              </h3>
              <p className="text-gray-600 text-sm">
                {translate("fipix.features.accurate.desc")}
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-brand-400 to-brand-600 rounded-xl shadow-2xl p-8 text-center text-white">
            <h3 className="text-2xl lg:text-3xl font-bold mb-3">
              {translate("fipix.ctaTitle")}
            </h3>
            <p className="text-lg mb-6 text-blue-100">
              {translate("fipix.ctaSubtitle")}
            </p>
            <Link to={"https://fipix.net/"} target="_blank">
              <button className="px-6 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all transform hover:scale-105 shadow-lg">
                {translate("fipix.ctaButton")}
              </button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Fipix;
